// extracted by mini-css-extract-plugin
export default {"info":"style_info__mOyJ0","spinner":"style_spinner__5teTN"};